import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { PageWrapper as AnytimePageWrapper } from '../anytime-ui/index';
import { changeAccountInfo, logout } from '../actions';
import firebase from '../firebase';
import { useAccountInfo } from '../hooks';

const PageWrapper: React.FC<{ children: any }> = ({ children }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const account = useAccountInfo();

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user === null || user.email === null) {
        return;
      }
      dispatch(changeAccountInfo({ email: user.email, id: user.uid }));
    });
    return () => {
      unsubscribe();
    };
  }, [dispatch, history]);

  return (
    <AnytimePageWrapper
      appName="AtCoder Anytime"
      accountId={account.id}
      inverted={false}
      onNavigateHome={() => history.push('/')}
      onNavigateContests={() => history.push('/contests')}
      onNavigateRanking={() => history.push('/ranking')}
      onNavigateProfile={() => history.push(`/users/${account.id}`)}
      onLogout={() => dispatch(logout())}
      onNavigateContact={() => history.push('/contact')}
    >
      {children}
    </AnytimePageWrapper>
  );
};

export default PageWrapper;
